<template>
  <div id="GoTop" @click="GoTop()" style="display:none;">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  methods: {
    scrollToTop(el) {
      let topBtn = document.getElementById('GoTop');
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let browserHeight = window.outerHeight;
      // console.log(browserHeight)
      // console.log(scrollTop)
      if (scrollTop > browserHeight) {
        topBtn.style.display = 'block';
      } else {
        topBtn.style.display = 'none';
      }
    },
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop);
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
  /*display: none;*/
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: #a82d29;
  font-size: 30px;
}
@media screen and (max-width: 997px) {
  #GoTop {
    right: 0px;
    bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue